<div class="mx-4">
    <div class="bg-gris-claro flex flex-col w-full px-6 py-10 my-10 justify-center rounded-md">
        <div class="flex flex-col justify-center">
            <div class="check w-full flex justify-center mb-4 text-center items-center mx-auto rounded-full border-2 border-info">
                <span class="text-5xl material-icons-outlined">done</span>

            </div>
            <div class="w-full flex justify-center mb-4">
                <p class="text-xl text-center"> {{'checkout.exitoCompra' | translate}} </p>
            </div>
            <div class="w-full flex flex-col justify-center  mb-4">
                <p class="w-full flex justify-center text-center"> {{'checkout.msgExito' | translate}} </p>

                <p class="w-full flex justify-center lg:hidden">{{'pageTurnos.muchas_gracias' | translate}}</p>
                <div class="w-full flex justify-center">
                    <button (click)="close()" class="hidden lg:flex bg-principal-hover text-center w-min-w px-4 text-info justify-center h-full py-1 my-4 rounded">
                        <span class="self-center lg:w-full text-white"> {{'buttons.cerrar' | translate}} </span>
                    </button>
                </div>


            </div>
        </div>

    </div>